import type { APIResult } from "./types";

import { getMaintenanceTyreTests } from "./generated/calls/maintenance-tyre-tests/maintenance-tyre-tests";
import type { MaintenanceTyreTests as MaintenanceTyreTestDTO } from "./generated/models";
import { buildHeaders } from "./helpers/headerHelper";
import { postgrestError } from "./helpers/postgrestErrorHelper";

export type { MaintenanceTyreTestDTO };

/**
 * Fetches all fleet maintenance tyre tests from the API.
 *
 * Returns an API result containing the fetched tyre tests, or a
 * controlled failure if the request could not be completed.
 */
export async function fetchFleetMaintenanceTyreTests(): Promise<
  APIResult<MaintenanceTyreTestDTO[]>
> {
  try {
    const headers = buildHeaders();
    const tyreTestsFetchRes = await getMaintenanceTyreTests(undefined, {
      headers,
    });

    switch (tyreTestsFetchRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: tyreTestsFetchRes.data,
        };
      default:
        throw postgrestError("Fetch failed", tyreTestsFetchRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
